import { styled } from 'goober';
export var ELWrap = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        backgroundColor: 'white',
        fontSize: theme.font.size,
        flexGrow: 1,
    });
});
export var ELHeader = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: '44px',
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: theme.colors.ui.dark,
        padding: '0px 20px',
    });
});
export var ELHeaderLogo = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100px',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    });
});
export var ELToolbar = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%',
        flexWrap: 'wrap',
        fontSize: '12px',
        borderBottom: "1px solid ".concat(theme.borderColor),
        '>div': {
            height: '40px',
            borderTop: "1px solid ".concat(theme.borderColor),
            display: 'flex',
            flexGrow: 0,
        },
    });
});
export var ELExpiredInfo = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: '200px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '22px',
    });
});
